/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 11:35 AM
 *
 */

import { Fragment } from 'react';
import LetteredAvatar from 'react-avatar';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { CaretDown } from 'phosphor-react';
import { useAppDispatch, useAppSelector } from 'stores';

import { removeAuth } from 'features/auth';

const ImageAvatar = () => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();

  const onLogOut = () => {
    dispatch(removeAuth());
    toast.loading('Logging Out!');
    if (process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT') {
      window.open('https://dev.app.sunya.health', '_self');
    } else {
      window.open('https://app.sunya.health', '_self');
    }
  };

  return (
    <Menu as="div" className="relative">
      <Menu.Button>
        <div className="flex items-center space-x-2">
          {user?.image ? (
            <div className="relative h-8 w-8 overflow-hidden rounded-full bg-white">
              <img src={user?.image} className="object-cover" alt="Avatar" />
            </div>
          ) : (
            <LetteredAvatar name={user?.name} size="30" round={true} maxInitials={2} />
          )}

          <div className="flex text-gray-900">
            <span className="text-xl font-medium">
              Hi, {user?.name ? user?.name.split(' ')[0] : ''}
            </span>
            <CaretDown size={22} />
          </div>
        </div>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute top-12 right-0 mt-2 w-64 origin-top-right divide-y divide-gray-100 rounded-md bg-white py-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <Menu.Item as="div">
            {({ active: btnActive }) => (
              <button
                onClick={() => navigate('/profile')}
                className={`${
                  btnActive ? `bg-gray-100 text-gray-800 ` : 'text-gray-700'
                } group flex w-full items-center rounded-md px-4 py-3 text-xl font-medium`}
              >
                View Profile
              </button>
            )}
          </Menu.Item>
          <Menu.Item as="div">
            {({ active: btnActive }) => (
              <button
                onClick={onLogOut}
                className={`${
                  btnActive ? `bg-gray-100 text-gray-800 ` : 'text-gray-700'
                } group flex w-full items-center  rounded-md px-4 py-3 text-xl font-medium`}
              >
                Log out
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default ImageAvatar;
